

import React, { ReactNode} from 'react';
import { Grid, Theme, Typography, useTheme } from "@mui/material";
import { SxProps } from '@mui/system';

    
export type FormPropertySectionProps = {
    label: ReactNode,
    sx?: SxProps<Theme>;
    children: ReactNode
};

export default function FormPropertySection({label, 
    children,
    sx} : FormPropertySectionProps) {
    

    const theme = useTheme();

    return (
        <Grid container sx={{
            '& + &': {
                marginTop: theme.spacing(1)
            },
            ...sx}}>
            <Grid size={12}>
                <Typography variant="subtitle1" sx={{
                    fontWeight: 600
                }} >
                    {label}
                </Typography>
            </Grid>
            {children}
        </Grid>
    );
  }
